// @flow
import type {Action} from '../../../state/types'

export type SetLoadingPayload = {
  isLoading: boolean,
}

const id = 'session/SET_LOADING'

export const setLoading = (isLoading: boolean): Action<SetLoadingPayload> => ({
  type: id,
  payload: {
    isLoading,
  }
})

setLoading.id = id
